import axios from 'axios';
import { useAuthStore } from '../store/authStore';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const hadAuthHeader = Boolean(
      error.config?.headers?.Authorization || error.config?.headers?.authorization
    );

    // Only auto-logout when a request that expected authentication (sent Authorization)
    // comes back as 401. This prevents public pages (like the landing page) from being
    // hard-redirected to /login due to background checks or public endpoints.
    if (status === 401 && hadAuthHeader) {
      useAuthStore.getState().logout();
    }

    return Promise.reject(error);
  }
);

export default api;
